export default __webpack_public_path__ + "static/media/topcoder.2a705f6e.jpg";